import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/invite.reducer";
import {EffectsModule} from "@ngrx/effects";
import {InviteEffects} from "./core/invite.effects";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InviteUserComponent} from "./screen/invite-user.component";
import {NewUserComponent} from "./components/new-user/new-user.component";
import {ExistingUserComponent} from "./components/exsisting-user/existing-user.component";
import {SharedModule} from "../../shared/shared.module";
import {MaterialModule} from "../../shared/material-module";
import {EmailPreviewComponent} from "./components/email-preview/email-preview.component";


@NgModule({
  declarations: [
    InviteUserComponent,
    NewUserComponent,
    ExistingUserComponent,
    EmailPreviewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StoreModule.forFeature("ss-cord.invite", reducer),
    EffectsModule.forFeature(
      [InviteEffects]
    ),
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class InviteModule {
}
